"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_EXPONENTIAL_BACKOFF = exports.DEBOUNCE_TIMEOUT = void 0;
exports.DEBOUNCE_TIMEOUT = 1 * 1000; // 3 seconds
exports.MAX_EXPONENTIAL_BACKOFF = 64 * 1000; // 64 seconds
